import axios from "axios";
import { API_BASE } from "./mailService";

const BY_IDS_URL = `${API_BASE}/api/designDiscounts/by-ids`;
const DESIGN_DISCOUNTS_URL = `${API_BASE}/api/designDiscounts`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Fetch design discounts for the given design ids (Firestore document ids).
 * @param {string[]} designIds
 * @returns {Promise<Record<string, { value: number, isPercentage: boolean }>>} map of designId -> discount
 */
export const getDesignDiscountsMap = async (designIds) => {
  if (!designIds?.length) return {};
  const res = await axios.post(BY_IDS_URL, designIds);
  const list = Array.isArray(res.data) ? res.data : [];
  const map = {};
  list.forEach((d) => {
    const key = d.designId || d.DesignId;
    if (key) {
      map[key] = {
        value: d.value ?? d.Value ?? 0,
        isPercentage: d.isPercentage ?? d.IsPercentage ?? false,
      };
    }
  });
  return map;
};

/**
 * Save or update design discount (requires admin auth). Used by Items page when adding/editing gallery items.
 * @param {{ designId: string, designName?: string, isPercentage: boolean, value: number }} payload
 */
export const saveDesignDiscount = async (payload) => {
  const res = await axios.post(DESIGN_DISCOUNTS_URL, payload, { headers: getAuthHeaders() });
  return res.data;
};

export const deleteDesignDiscountByDesignId = async (designId) => {
  await axios.delete(`${DESIGN_DISCOUNTS_URL}/by-design-id/${encodeURIComponent(designId)}`);
};
